/**
 * **Le seul endroit du code où `fetch` est appelé.**
 *
 * L'appel est résolu à l'exécution et non à l'import : `globalThis.fetch`
 * capturé au chargement du module serait figé, et un `fetch` installé plus tard
 * — MSW dans les tests, un polyfill, un instrument de mesure — ne serait jamais
 * vu. C'est le même piège que celui décrit dans `tests/setup.ts`, du côté
 * client cette fois.
 */
export function sendRequest(request: Request): Promise<Response> {
  return fetch(request);
}
